import { UserInfo } from "@/utils/userinfo/types";
import type { MenuProps } from "antd";
import WechatIcon from "@/assets/icons/common/wechat";
import SkypeIcon from "@/assets/icons/common/skype";
import DocIcon from "@/assets/icons/common/doc";
import styled from "styled-components";
import { getDomain } from "project-config/utils/domain";
import { BusinessType } from "project-config/constants";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
const t = getTranslateNsT("center");

const RightArrow = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  border-left: 2px solid #565963;
  border-bottom: 2px solid #565963;
  transform: rotate(225deg);
  right: 0;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: 4px;
  min-height: 42px;
  border-bottom: 1px solid #32343e;
  svg {
    height: 14px;
  }
  color: #e8ebf0 !important;
  &:hover {
    color: ${getDomain() ? "#FA6041 !important" : "#13CB75 !important"};
    svg path {
      fill: ${getDomain() ? "#FA6041" : "#13a661"};
    }
    ${RightArrow} {
      border-color: #ffffff;
    }
  }
`;
const ServiceMenuItemTitle = styled.label`
  color: #8d8f95;
  font-size: 12px;
  line-height: 17px;
`;
const ServiceMenuItemContent = styled.span`
  color: #e8ebf0;
  font-size: 14px;
  line-height: 20px;
`;

export const TitleMenuItem = styled(MenuItem)`
  flex-direction: column;
  gap: unset;
  align-items: unset;
  justify-content: center;
  padding: 8px 0;
`;

export const getServiceMenuList = (userInfo: UserInfo) => {
  const serviceMenu: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <MenuItem
          as="a"
          href={
            !getDomain()
              ? `https://wpa1.qq.com/ujoglPGq?_type=wpa&qidian=true`
              : `https://api.whatsapp.com/send/?phone=8618124758259&text=Hello.May%20i%20help%20you?`
          }
          rel="nofollow noopenner"
          target="_blank"
        >
          {getDomain() ? <SkypeIcon /> : <WechatIcon />}
          {t("businessman_query_text")}
          <RightArrow />
        </MenuItem>
      ),
    },
    {
      key: "2",
      label: (
        <MenuItem
          as="a"
          href={
            !getDomain()
              ? `https://www.renderbus.com/support-new/`
              : `https://www.foxrenderfarm.com/support/index`
          }
          rel="nofollow noopenner"
          target="_blank"
        >
          <DocIcon />
          {t("businessman_query_doc")}
          <RightArrow />
        </MenuItem>
      ),
    },
    {
      key: "3",
      label: (
        <TitleMenuItem>
          <ServiceMenuItemTitle>
            {getDomain()
              ? t("businessman_service_email")
              : t("businessman_service_text")}
          </ServiceMenuItemTitle>
          <ServiceMenuItemContent>
            {getDomain()
              ? t("businessman_service_contact_email")
              : t("businessman_service_contact")}
          </ServiceMenuItemContent>
        </TitleMenuItem>
      ),
    },
  ];
  const isPictureUser = userInfo.businessType === BusinessType.Picture;
  const contact = getDomain() ? userInfo.salesmanEmail : userInfo.salesmanPhone;
  if (!isPictureUser && (userInfo.salesmanName || contact)) {
    serviceMenu.push({
      key: "4",
      label: (
        <TitleMenuItem>
          <ServiceMenuItemTitle>
            {t("businessman_service_manager")}
          </ServiceMenuItemTitle>
          <ServiceMenuItemContent>
            {userInfo.salesmanName || ""}
          </ServiceMenuItemContent>
          <ServiceMenuItemContent>{contact || ""}</ServiceMenuItemContent>
        </TitleMenuItem>
      ),
    });
  }
  return serviceMenu;
};
